export const formatTextWithBold = (text: string): string => {
  // Remove spaces between numbers and periods in numbered lists
  let formattedText = text.replace(/(\d+)\s*\./g, '$1.');
  
  // Convert both ### and ** patterns to bold text
  formattedText = formattedText
    .replace(/###(.*?)###/g, '<strong>$1</strong>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  return formattedText;
};